import { TTrajectoryAction } from "@/types";

import ActionsList from "./ActionsList";
import AvailableActionsList from "./AvailableActionsList";

type ActionPlanProps = {
  isInEdition?: boolean;
  onEditionChange: () => void;
  availableActions: Array<TTrajectoryAction>;
  actions: Array<TTrajectoryAction>;
};

function ActionPlan({
  isInEdition = false,
  onEditionChange,
  availableActions,
  actions,
}: ActionPlanProps) {
  return (
    <>
      {isInEdition && (
        <AvailableActionsList availableActions={availableActions} />
      )}
      <ActionsList
        isInEdition={isInEdition}
        onEditionChange={onEditionChange}
        actions={actions}
      />
    </>
  );
}

export default ActionPlan;
